import React from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { ToastProvider } from './context/ToastContext';
import PWAStatus from './components/layout/PWAStatus';

import MenuPublico from './components/publico/MenuPublico';
import SeguimientoPedido from './components/publico/SeguimientoPedido';
import CartaDigital from './components/publico/CartaDigital';
import CalculadoraCredito from './components/publico/CalculadoraCredito';
import Privacidad from './components/publico/Privacidad';

/**
 * Aplicación PÚBLICA — la que ve el cliente en piedrayfuego.cl
 *
 * Contiene únicamente carta, menú, seguimiento de pedido y privacidad.
 * El panel de administración NO se importa acá, así que su código ni siquiera
 * llega al navegador del cliente: no hay pantalla de login que encontrar ni
 * rutas internas que adivinar.
 *
 * El panel vive en otro sitio de hosting (ver firebase.json → target "admin").
 */
const router = createBrowserRouter([
  { path: '/',             element: <MenuPublico /> },
  { path: '/menu',         element: <Navigate to="/" replace /> },
  { path: '/carta',        element: <Navigate to="/" replace /> },
  { path: '/pedido/:id',   element: <SeguimientoPedido /> },
  { path: '/mesa/:mesaId', element: <CartaDigital /> },
  { path: '/carta-local',  element: <MenuPublico soloVer /> },   // QR del mesón: solo mirar
  { path: '/calculadora',  element: <CalculadoraCredito /> },
  { path: '/privacidad',   element: <Privacidad /> },

  // Cualquier otra ruta (incluidas las del panel) devuelve a la carta.
  { path: '*',             element: <Navigate to="/" replace /> },
]);

export default function AppPublico() {
  return (
    <ToastProvider>
      <RouterProvider router={router} />
      <PWAStatus />
    </ToastProvider>
  );
}
